import React from "react";
import { Paperclip, X, FileText } from "lucide-react";
import { fileUrl } from "@/lib/api";
import { toast } from "sonner";

const MAX = 4;
const MAX_BYTES = 10 * 1024 * 1024;

export function AttachPicker({ files, onChange, testId = "attach" }) {
  const onPick = (e) => {
    const picked = Array.from(e.target.files || []);
    e.target.value = "";
    const ok = picked.filter((f) => {
      if (!/^image\/|^application\/pdf$/.test(f.type)) { toast.error(`${f.name}: only photos and PDFs`); return false; }
      if (f.size > MAX_BYTES) { toast.error(`${f.name} is over 10MB`); return false; }
      return true;
    });
    Promise.all(ok.map((f) => new Promise((res) => { const r = new FileReader(); r.onload = () => res({ name: f.name, data_url: r.result }); r.readAsDataURL(f); })))
      .then((arr) => {
        const next = [...files, ...arr];
        if (next.length > MAX) toast.error(`Up to ${MAX} files per message`);
        onChange(next.slice(0, MAX));
      });
  };
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <label className="inline-flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground cursor-pointer" data-testid={`${testId}-button`}>
        <Paperclip className="h-3.5 w-3.5" />Attach photo or receipt
        <input type="file" multiple accept="image/*,application/pdf" className="hidden" data-testid={`${testId}-input`} onChange={onPick} />
      </label>
      {files.map((f, i) => (
        <span key={i} data-testid={`${testId}-chip-${i}`} className="inline-flex items-center gap-1 text-xs bg-secondary rounded-full pl-2.5 pr-1 py-0.5 max-w-[180px]">
          <span className="truncate">{f.name}</span>
          <button type="button" data-testid={`${testId}-remove-${i}`} onClick={() => onChange(files.filter((_, j) => j !== i))} className="p-0.5 hover:text-[#9E382A]"><X className="h-3 w-3" /></button>
        </span>
      ))}
    </div>
  );
}

export function AttachmentList({ items, light, msgId }) {
  if (!items?.length) return null;
  return (
    <div className="flex gap-2 flex-wrap mt-2">
      {items.map((a, i) => a.content_type?.startsWith("image/") ? (
        <a key={i} href={fileUrl(a.path)} target="_blank" rel="noreferrer" data-testid={`attachment-${msgId}-${i}`}>
          <img src={fileUrl(a.path)} alt={a.name} className="h-24 w-24 object-cover rounded-md border border-border" />
        </a>
      ) : (
        <a key={i} href={fileUrl(a.path)} target="_blank" rel="noreferrer" data-testid={`attachment-${msgId}-${i}`}
          className={`inline-flex items-center gap-1.5 text-xs underline px-2 py-1 rounded-md ${light ? "bg-white/15" : "bg-secondary"}`}>
          <FileText className="h-3.5 w-3.5" /><span className="truncate max-w-[160px]">{a.name}</span>
        </a>
      ))}
    </div>
  );
}
